const getInitials = (name: string) => {
  const words = name.split(' ');
  const initials = words.map(w => w[0].toUpperCase());
  return initials.join('');
};

export default getInitials;
